export default [
  {
    name: 'Dashboard',
    description: 'Dashboard',
    route: '/dashboard',
    visible: true,

  },
  {
    name: 'Configurações',
    description: 'Configurações do Tracker',
    visible: true,
    children: [
      {
        name: 'Empresas',
        description: 'Listagem de Empresas',
        route: '/company',
        visible: true,
      },
      {
        name: 'Fluxo de Atividades',
        description: 'Listagem de Fluxo de Atividades',
        route: '/flow',
        visible: true,
      },
      {
        name: 'Usuários',
        description: 'Listagem de Usuários',
        route: '/account/list',
        visible: true,
      },
    ],
  },
  {
    name: 'Notas',
    description: 'Menu de Notas',
    visible: true,
    children: [
      {
        name: 'Consultar',
        description: 'Listagem de todas as Notas',
        route: '/invoice/list',
        visible: true,
      },
      {
        name: 'Registro',
        description: 'Registro e Consulta de Notas',
        route: '/invoice/create',
        visible: true,
      },
      {
        name: 'Registro em Lote',
        description: 'Registro em lote através de importação de arquivo',
        route: '/invoice/lot',
        visible: true,
      },
      {
        name: 'Execução de Fluxo',
        description: 'Execução de Fluxo de Atividades',
        route: '/invoice/check',
        visible: true,
      },
      {
        name: 'Consulta de Fluxo',
        description: 'Consulta de Fluxo de Atividades',
        route: '/invoice/search',
        visible: true,
      },

    ],
  },


];




// WEBPACK FOOTER //
// ./src/app/utils/drawerMenu.js